import React, { useEffect, useState } from "react";
import Hero from "../../../Components/Website/FindSpecialist/Hero";
import PublicLayout from "../../../layouts/PublicLayout";
import Recommendation from "../../../Components/Website/FindSpecialist/Recommendation";
import Categories from "../../../Components/Website/FindSpecialist/Specialties";
import api from "../../../configs/api";

export default function FindSpecialist() {
  const [specialists, setSpecialists] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleSearch = async (specialistName, specialization, keywords) => {
    setIsLoading(true);
    try {
      const response = await api.get("specialist/filter_specialists", {
        params: {
          specialistName,
          specialization: specialization?.map((spec) => spec.value).join(","),
          keywords,
        },
      });
      setSpecialists(response.data || []);
    } catch (error) {
      console.error("Error fetching specialists:", error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    handleSearch()
  }, [])
  
  return (
    <PublicLayout>
        <Hero onSearch={handleSearch} />
        <Recommendation specialists={specialists} isLoading={isLoading} />
        <Categories />
    </PublicLayout>
  );
}
